import axios from 'axios';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth';
// eslint-disable-next-line camelcase
import { hex_sha1_utf_8 } from '@/utils/sha1.js';

const service = axios.create({
  baseURL: '/',
  // withCredentials: true,
  headers: {
    'Cache-Control': 'no-cache',
    Accept: 'application/json',
    'Content-Type': 'application/json',

  },
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    const date = Date.now();
    const app_code = process.env.VUE_APP_APPLICATION_CODE;
    const app_secret_key = process.env.VUE_APP_APPLICATION_SECRET_KEY;
    const app_sign = hex_sha1_utf_8(app_code + app_secret_key + date + JSON.stringify(config.data));
    const token = getToken();
    config.headers.AppCode = app_code;
    config.headers.AppTimestamp = date;
    config.headers.AppSign = app_sign;
    config.headers[`${app_code}Ticket`] = token;
    config.baseURL = process.env.VUE_APP_API;
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

service.interceptors.response.use((response) => {
  const res = response.data;
  if (res.code === '001107' || res.code === '001108') {
    Message({
      message: res.msg,
      type: 'error',
      duration: 1000,
      onClose: () => {
        // window.location.href = '/toLogin';
      },
    });
    return Promise.reject(res.msg || 'error');
  }
  if (res.code !== '0') {
    Message.error(res.msg || '系统繁忙');
    return Promise.reject(res.msg || '系统繁忙');
  }
  return res;
}, (error) => {
  Message.error(error.msg || '系统繁忙');
  return Promise.reject(error);
});

export default service;
